"use client";

import React, { createContext, useContext } from "react";

import { CountryInfo } from "../type/location-from.type";

// Full context type
type CountryInfoContextType = CountryInfo;

// Create context
const CountryInfoContext = createContext<CountryInfoContextType | undefined>(
  undefined
);

// Hook to consume context
export const useCountryInfo = () => {
  const context = useContext(CountryInfoContext);
  if (!context) {
    throw new Error("useCountryInfo must be used within a CountryInfoProvider");
  }
  return context;
};

// Props for the provider
interface CountryInfoProviderProps {
  readonly countryInfo: CountryInfo;
  readonly children: React.ReactNode;
}

// Context Provider
export function CountryInfoProvider({
  countryInfo,
  children,
}: CountryInfoProviderProps) {
  return (
    <CountryInfoContext.Provider value={countryInfo}>
      {children}
    </CountryInfoContext.Provider>
  );
}
